(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ironside-banners"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ironside-banners')) {
  customElements.define('ironside-banners', class extends HTMLElement {
    connectedCallback() {
      this.promos = [...this.querySelectorAll('[data-promo]')];
      if (!this.promos.length) return;
      this.addEventListener('click', (e) => { const a = e.target.closest('[data-promo]'); if (a) this.send('select_promotion', a); });
      if (!('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver((entries) => entries.forEach((en) => {
        if (en.isIntersecting) { this.send('view_promotion', en.target); this.io.unobserve(en.target); }
      }), { threshold: 0.5 });
      this.promos.forEach((p) => this.io.observe(p));
    }
    disconnectedCallback() { this.io?.disconnect(); }
    send(name, el) {
      const d = el.dataset, slot = this.dataset.slot + '_' + d.index;
      const payload = { promotion_id: d.promotionId, promotion_name: d.promotionName, creative_name: d.creativeName, creative_slot: slot,
        items: [{ promotion_id: d.promotionId, promotion_name: d.promotionName, creative_name: d.creativeName, creative_slot: slot }] };
      try { if (typeof window.gtag === 'function') window.gtag('event', name, payload); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: name, ecommerce: payload }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + name, payload); } catch (e) {}
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-category-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ironside-category-carousel')) {
    customElements.define('ironside-category-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.icc__track');
        this.arrows = this.querySelectorAll('.icc__arrow');
        if (!this.track) return;
        // Listeners en elementos propios: se agregan una sola vez aunque el editor reconecte la sección.
        if (!this.ready) {
          this.ready = true;
          this.arrows.forEach((b) => b.addEventListener('click', () => {
            this.track.scrollBy({ left: Number(b.dataset.dir) * this.track.clientWidth * 0.8, behavior: 'smooth' });
          }));
          this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
          if (this.dataset.track === 'true') {
            this.track.addEventListener('click', (e) => {
              const a = e.target.closest('.icc__link');
              if (a) this.send('select_promotion', a);
            });
          }
        }
        // Recalcula flechas al cambiar el ancho (en vez de un listener global de resize que nunca se quita).
        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(() => this.updateArrows());
          this.resizeObserver.observe(this.track);
        }
        this.updateArrows();
        if (this.dataset.track !== 'true' || !('IntersectionObserver' in window)) return;
        this.viewObserver = new IntersectionObserver((entries) => {
          entries.forEach((en) => { if (en.isIntersecting) { this.send('view_promotion', en.target); this.viewObserver.unobserve(en.target); } });
        }, { threshold: 0.6 });
        this.querySelectorAll('.icc__link').forEach((a) => this.viewObserver.observe(a));
      }
      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.viewObserver) this.viewObserver.disconnect();
      }
      updateArrows() {
        if (this.arrows.length < 2) return;
        const t = this.track, max = t.scrollWidth - t.clientWidth - 2;
        this.arrows.forEach((b) => { b.hidden = max <= 0; });
        this.arrows[0].disabled = t.scrollLeft <= 2;
        this.arrows[1].disabled = t.scrollLeft >= max;
      }
      send(eventName, a) {
        const promo = {
          promotion_id: this.dataset.promotionId,
          promotion_name: this.dataset.promotionName,
          creative_name: a.dataset.name,
          creative_slot: this.dataset.location + '_' + a.dataset.index,
          location_id: this.dataset.location
        };
        const payload = Object.assign({}, promo, {
          items: [Object.assign({ item_id: 'cat_' + a.dataset.handle, item_name: a.dataset.name }, promo)]
        });
        try { if (typeof window.gtag === 'function') window.gtag('event', eventName, payload); } catch (e) {}
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: eventName, ecommerce: payload }); } catch (e) {}
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + eventName, payload); } catch (e) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-category-tiles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ironside-category-tiles')) {
    customElements.define('ironside-category-tiles', class extends HTMLElement {
      connectedCallback() {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const videos = this.querySelectorAll('.ict__video');
        if (videos.length && !reduce && 'IntersectionObserver' in window) {
          this.videoObserver = new IntersectionObserver((entries) => {
            entries.forEach((en) => {
              const v = en.target;
              if (en.isIntersecting) {
                if (!v.src && v.dataset.src) {
                  const small = window.matchMedia('(max-width: 749px)').matches;
                  v.src = (small && v.dataset.srcMobile) || v.dataset.src;
                }
                const p = v.play();
                if (p && p.then) p.then(() => v.classList.add('is-playing')).catch(() => {});
              } else if (!v.paused) {
                v.pause();
              }
            });
          }, { threshold: 0.25 });
          videos.forEach((v) => this.videoObserver.observe(v));
        }

        if (this.dataset.track !== 'true') return;
        // Una sola vez por elemento, aunque el editor del theme lo desconecte y reconecte.
        if (!this.onTileClick) {
          this.onTileClick = (e) => {
            const a = e.target.closest('.ict__tile');
            if (a) this.send('select_promotion', a);
          };
          this.addEventListener('click', this.onTileClick);
        }
        if ('IntersectionObserver' in window) {
          this.viewObserver = new IntersectionObserver((entries) => {
            entries.forEach((en) => {
              if (en.isIntersecting) { this.send('view_promotion', en.target); this.viewObserver.unobserve(en.target); }
            });
          }, { threshold: 0.5 });
          this.querySelectorAll('.ict__tile').forEach((a) => this.viewObserver.observe(a));
        }
      }
      disconnectedCallback() {
        if (this.videoObserver) this.videoObserver.disconnect();
        if (this.viewObserver) this.viewObserver.disconnect();
      }
      send(eventName, a) {
        const promo = {
          promotion_id: a.dataset.promotionId,
          promotion_name: 'Home categorías · ' + a.dataset.name,
          creative_name: a.dataset.name,
          creative_slot: this.dataset.location + '_' + a.dataset.index,
          location_id: this.dataset.location
        };
        const payload = Object.assign({}, promo, {
          items: [Object.assign({ item_id: 'cat_' + a.dataset.handle, item_name: a.dataset.name }, promo)]
        });
        try { if (typeof window.gtag === 'function') window.gtag('event', eventName, payload); } catch (e) {}
        try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: eventName, ecommerce: payload }); } catch (e) {}
        try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + eventName, payload); } catch (e) {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-flash-deals"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('ironside-flash-deals')) {
  customElements.define('ironside-flash-deals', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.items = [...this.querySelectorAll('[data-item]')];
      this.list = { item_list_id: this.dataset.listId, item_list_name: this.dataset.listName };
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.track.scrollBy({ left: -this.track.clientWidth * 0.8, behavior: 'smooth' }));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.track.scrollBy({ left: this.track.clientWidth * 0.8, behavior: 'smooth' }));
      this.initArrows();
      this.initTimer();
      this.initTracking();
      this.addEventListener('click', (e) => {
        const add = e.target.closest('[data-add]');
        if (add) { e.preventDefault(); this.add(add); return; }
        const sel = e.target.closest('[data-select]');
        if (sel) this.track_('select_item', [this.item(sel.closest('[data-item]'))]);
      });
    }
    disconnectedCallback() { clearTimeout(this.t); this.io?.disconnect(); this.ro?.disconnect(); }

    // Flechas: se ocultan al inicio / al final del carrusel (y ambas si no hay scroll)
    initArrows() {
      const prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      if (!this.track || !prev || !next) return;
      const update = () => {
        const t = this.track, max = t.scrollWidth - t.clientWidth - 2;
        prev.disabled = t.scrollLeft <= 2;
        next.disabled = t.scrollLeft >= max;
        if (next.disabled && document.activeElement === next && !prev.disabled) prev.focus();
        if (prev.disabled && document.activeElement === prev && !next.disabled) next.focus();
      };
      this.track.addEventListener('scroll', update, { passive: true });
      if ('ResizeObserver' in window) { this.ro = new ResizeObserver(update); this.ro.observe(this.track); }
      update();
    }

    // Reloj de Chile: segundos restantes hasta la próxima hora de reinicio (ciclo de 24 h)
    remaining() {
      const p = new Intl.DateTimeFormat('en-GB', { timeZone: 'America/Santiago', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).formatToParts(new Date());
      const g = (t) => +p.find((x) => x.type === t).value;
      const now = g('hour') * 3600 + g('minute') * 60 + g('second');
      const r = ((+this.dataset.resetHour || 0) * 3600 - now + 86400) % 86400;
      return r === 0 ? 86400 : r;
    }
    initTimer() {
      const h = this.querySelector('[data-h]'); if (!h) return;
      const m = this.querySelector('[data-m]'), s = this.querySelector('[data-s]'), z = (n) => String(n).padStart(2, '0');
      const tick = () => { const r = this.remaining() % 86400; h.textContent = z(Math.floor(r / 3600)); m.textContent = z(Math.floor((r % 3600) / 60)); s.textContent = z(r % 60); };
      // alineado al cambio de segundo del reloj (igual que el hero) para que ambos contadores avancen juntos
      const loop = () => { tick(); this.t = setTimeout(loop, 1000 - (Date.now() % 1000)); };
      loop();
    }

    item(el) {
      return { item_id: el.dataset.itemId, item_variant: el.dataset.sku, item_name: el.dataset.name, item_brand: el.dataset.brand, item_category: el.dataset.category,
        price: +el.dataset.price, discount: +el.dataset.discount, index: +el.dataset.index, quantity: 1, ...this.list };
    }
    track_(name, items) {
      const payload = { ...this.list, currency: this.dataset.currency, value: items.reduce((a, i) => a + i.price, 0), items };
      try { if (typeof window.gtag === 'function') window.gtag('event', name, payload); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: name, ecommerce: payload }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + name, payload); } catch (e) {}
    }
    // view_item_list una vez por producto, cuando la tarjeta queda >=50% visible
    initTracking() {
      if (!this.items.length || !('IntersectionObserver' in window)) return;
      const seen = new Set(); let queue = [], timer;
      this.io = new IntersectionObserver((entries) => {
        entries.forEach((en) => { if (en.isIntersecting && !seen.has(en.target)) { seen.add(en.target); queue.push(this.item(en.target)); this.io.unobserve(en.target); } });
        clearTimeout(timer); timer = setTimeout(() => { if (queue.length) { this.track_('view_item_list', queue); queue = []; } }, 400);
      }, { threshold: 0.5 });
      this.items.forEach((i) => this.io.observe(i));
    }

    async add(btn) {
      const el = btn.closest('[data-item]'); btn.setAttribute('aria-busy', 'true');
      const drawers = [...document.querySelectorAll('cart-items-component')].map((c) => c.dataset.sectionId).filter(Boolean);
      try {
        const res = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +el.dataset.variantId, quantity: 1, properties: { _origen: this.dataset.origin } }], sections: drawers.join(',') || undefined }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.description || data.message || 'Error');
        this.track_('add_to_cart', [this.item(el)]);
        const cart = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js').then((r) => r.json());
        const ev = new Event('cart:update', { bubbles: true });
        ev.detail = { resource: cart, sourceId: this.id, data: { source: 'ironside-flash-deals', itemCount: cart.item_count, productId: el.dataset.productId, variantId: el.dataset.variantId, sections: data.sections } };
        document.dispatchEvent(ev);
        const drawer = document.querySelector('cart-drawer-component');
        if (drawer && typeof drawer.open === 'function') drawer.open(); else if (!window.Rebuy) window.location.href = (window.Shopify?.routes?.root || '/') + 'cart';
      } catch (e) {
        btn.textContent = 'Sin stock suficiente'; setTimeout(() => (btn.textContent = btn.dataset.label || 'Agregar al carro'), 2500);
      } finally { btn.removeAttribute('aria-busy'); }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-hero-carousel-cyber"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // Cuenta regresiva del hero Cyber: un solo intervalo para todos los contadores de la página.
    if (window.ihcCountdown) return;
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    window.ihcCountdown = function () {
      document.querySelectorAll('[data-ihc-cd]').forEach(function (el) {
        var end = Date.parse(el.dataset.ihcCd);
        if (isNaN(end)) return;
        var s = Math.max(0, Math.ceil((end - Date.now()) / 1000));
        if (s === 0) {
          if (!el.dataset.done && !el.querySelector('.ihc-cd__logo, .ihc-cd__cta')) { el.hidden = true; return; }
          el.querySelector('.ihc-cd__done').textContent = el.dataset.done;
          el.classList.add('is-done');
        } else {
          el.classList.remove('is-done');
          el.querySelector('[data-u="d"]').textContent = pad(Math.floor(s / 86400));
          el.querySelector('[data-u="h"]').textContent = pad(Math.floor((s % 86400) / 3600));
          el.querySelector('[data-u="m"]').textContent = pad(Math.floor((s % 3600) / 60));
          el.querySelector('[data-u="s"]').textContent = pad(s % 60);
        }
        el.hidden = false;
        el.classList.add('is-ready');
      });
    };
    // el JS de secciones se carga en todas las páginas: el intervalo solo corre si hay contadores
    var timer;
    var start = function () {
      if (timer || !document.querySelector('[data-ihc-cd]')) return;
      // alineado al cambio de segundo del reloj (igual que Flash Deals) para que ambos contadores avancen juntos
      timer = true;
      (function loop() { window.ihcCountdown(); setTimeout(loop, 1000 - (Date.now() % 1000)); })();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
    document.addEventListener('shopify:section:load', function () { window.ihcCountdown(); start(); });
  })();

  (function () {
    if (customElements.get('ironside-hero-carousel')) return;

    function sendPromo(eventName, el, location) {
      var promo = {
        promotion_id: el.dataset.promotionId,
        promotion_name: el.dataset.promotionName,
        creative_name: el.dataset.creativeName,
        creative_slot: el.dataset.creativeSlot,
        location_id: location
      };
      var payload = { promotion_id: promo.promotion_id, promotion_name: promo.promotion_name,
        creative_name: promo.creative_name, creative_slot: promo.creative_slot, location_id: location,
        items: [{ item_id: promo.promotion_id, item_name: promo.promotion_name, promotion_id: promo.promotion_id,
          promotion_name: promo.promotion_name, creative_name: promo.creative_name, creative_slot: promo.creative_slot, location_id: location }] };
      try { if (typeof window.gtag === 'function') window.gtag('event', eventName, payload); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: eventName, ecommerce: payload }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + eventName, payload); } catch (e) {}
    }

    class IronsideHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track-el]');
        this.slides = Array.from(this.querySelectorAll('.ihc__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.interval = parseInt(this.dataset.interval, 10) || 6000;
        this.style.setProperty('--ihc-interval', this.interval + 'ms');
        this.location = this.dataset.location;
        this.seen = new Set();
        this.userPaused = false;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.canAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !reduce && !window.Shopify?.designMode;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(+d.dataset.dot, true)));
        this.track.addEventListener('pointerup', () => this.play(), { passive: true });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
        });

        var st;
        this.track.addEventListener('scroll', () => {
          clearTimeout(st);
          st = setTimeout(() => { this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth)); }, 80);
        }, { passive: true });

        if (this.dataset.track === 'true') {
          this.addEventListener('click', (e) => {
            var a = e.target.closest('[data-promo-click]');
            if (a) sendPromo('select_promotion', a.closest('.ihc__slide'), this.location);
          });
        }

        this.visObs = new IntersectionObserver(([en]) => {
          this.inView = en.isIntersecting;
          if (this.inView) this.trackView();
          this.inView && !this.userPaused ? this.play() : this.stop();
        }, { threshold: 0.5 });
        this.visObs.observe(this);
        document.addEventListener('visibilitychange', () => { document.hidden ? this.stop() : (!this.userPaused && this.play()); });
        this.setActive(0);
      }
      disconnectedCallback() { this.stop(); this.io?.disconnect(); this.visObs?.disconnect(); }
      go(i, manual) {
        var n = this.slides.length;
        i = ((i % n) + n) % n;
        this.track.scrollTo({ left: i * this.track.clientWidth });
        this.setActive(i);
        if (manual && !this.userPaused) this.play();
      }
      trackView() {
        var el = this.slides[this.index];
        if (this.dataset.track !== 'true' || !this.inView || !el || this.seen.has(el)) return;
        this.seen.add(el);
        sendPromo('view_promotion', el, this.location);
      }
      setActive(i) {
        this.index = i;
        this.trackView();
        this.slides.forEach((s, k) => { s.toggleAttribute('inert', k !== i); s.setAttribute('aria-hidden', k !== i); });
        this.dots.forEach((d, k) => d.setAttribute('aria-selected', k === i));
        // reinicia la animación de progreso
        if (this.hasAttribute('data-playing')) { this.removeAttribute('data-playing'); void this.offsetWidth; this.setAttribute('data-playing', ''); }
      }
      play() {
        if (!this.canAutoplay) return;
        this.stop();
        this.setAttribute('data-playing', '');
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }
      stop() { clearInterval(this.timer); this.removeAttribute('data-playing'); }
    }
    customElements.define('ironside-hero-carousel', IronsideHeroCarousel);

    document.addEventListener('shopify:block:select', (e) => {
      var c = e.target.closest?.('ironside-hero-carousel');
      if (c) c.go(+e.target.dataset.index);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ironside-hero-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('ironside-hero-carousel')) return;

    function sendPromo(eventName, el, location) {
      var promo = {
        promotion_id: el.dataset.promotionId,
        promotion_name: el.dataset.promotionName,
        creative_name: el.dataset.creativeName,
        creative_slot: el.dataset.creativeSlot,
        location_id: location
      };
      var payload = { promotion_id: promo.promotion_id, promotion_name: promo.promotion_name,
        creative_name: promo.creative_name, creative_slot: promo.creative_slot, location_id: location,
        items: [{ item_id: promo.promotion_id, item_name: promo.promotion_name, promotion_id: promo.promotion_id,
          promotion_name: promo.promotion_name, creative_name: promo.creative_name, creative_slot: promo.creative_slot, location_id: location }] };
      try { if (typeof window.gtag === 'function') window.gtag('event', eventName, payload); } catch (e) {}
      try { window.dataLayer = window.dataLayer || []; window.dataLayer.push({ ecommerce: null }); window.dataLayer.push({ event: eventName, ecommerce: payload }); } catch (e) {}
      try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('ironside:' + eventName, payload); } catch (e) {}
    }

    class IronsideHeroCarousel extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track-el]');
        this.slides = Array.from(this.querySelectorAll('.ihc__slide'));
        this.dots = Array.from(this.querySelectorAll('[data-dot]'));
        this.index = 0;
        this.interval = parseInt(this.dataset.interval, 10) || 6000;
        this.style.setProperty('--ihc-interval', this.interval + 'ms');
        this.location = this.dataset.location;
        this.seen = new Set();
        this.userPaused = false;
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.canAutoplay = this.dataset.autoplay === 'true' && this.slides.length > 1 && !reduce && !window.Shopify?.designMode;

        this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.index - 1, true));
        this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.index + 1, true));
        this.dots.forEach((d) => d.addEventListener('click', () => this.go(+d.dataset.dot, true)));
        this.track.addEventListener('pointerup', () => this.play(), { passive: true });
        this.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') this.go(this.index - 1, true);
          if (e.key === 'ArrowRight') this.go(this.index + 1, true);
        });

        var st;
        this.track.addEventListener('scroll', () => {
          clearTimeout(st);
          st = setTimeout(() => { this.setActive(Math.round(this.track.scrollLeft / this.track.clientWidth)); }, 80);
        }, { passive: true });

        if (this.dataset.track === 'true') {
          this.addEventListener('click', (e) => {
            var a = e.target.closest('[data-promo-click]');
            if (a) sendPromo('select_promotion', a.closest('.ihc__slide'), this.location);
          });
        }

        this.visObs = new IntersectionObserver(([en]) => {
          this.inView = en.isIntersecting;
          if (this.inView) this.trackView();
          this.inView && !this.userPaused ? this.play() : this.stop();
        }, { threshold: 0.5 });
        this.visObs.observe(this);
        document.addEventListener('visibilitychange', () => { document.hidden ? this.stop() : (!this.userPaused && this.play()); });
        this.initVideos();
        this.setActive(0);
      }
      initVideos() {
        // El video parte DESPUÉS de que cargue la capa/logo del slide (si no, compiten por ancho de banda
        // y el texto del hero aparece tarde). Con ahorro de datos o 2G/3G solo se muestra el poster.
        this.videos = Array.from(this.querySelectorAll('video[data-vd]'));
        if (!this.videos.length) return;
        var mq = window.matchMedia('(max-width: 749px)');
        var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var c = navigator.connection || {};
        var slow = c.saveData || /(^|-)2g|3g/.test(c.effectiveType || '');
        var setPoster = () => this.videos.forEach((v) => { var p = mq.matches ? v.dataset.posterM : v.dataset.posterD; if (p) v.poster = p; });
        setPoster();
        mq.addEventListener?.('change', setPoster);
        if (reduce || slow) return;
        var pick = (json, h) => {
          try {
            var mp4 = JSON.parse(json).sources.filter((x) => x.format === 'mp4').sort((x, y) => x.height - y.height);
            var s = mp4.filter((x) => x.height <= h).pop() || mp4[0];
            return s ? s.url : '';
          } catch (e) { return ''; }
        };
        var start = (v) => {
          // móvil 480p · escritorio 720p (2G/3G/ahorro de datos ya quedan solo con poster)
          var src = mq.matches ? pick(v.dataset.vm, 480) : pick(v.dataset.vd, 720);
          if (!src || v.dataset.cur === src) return;
          v.dataset.cur = src; v.src = src; v.muted = true; v.preload = 'auto';
          v.play().catch(() => {});
        };
        var idle = (fn) => (window.requestIdleCallback ? requestIdleCallback(fn, { timeout: 1500 }) : setTimeout(fn, 200));
        this.videos.forEach((v) => {
          var img = v.parentElement.querySelector('.ihc__logo-full img, .ihc__logo img');
          var go = () => idle(() => start(v));
          if (!img || img.complete) go();
          else { img.addEventListener('load', go, { once: true }); img.addEventListener('error', go, { once: true }); }
        });
        mq.addEventListener?.('change', () => this.videos.forEach((v) => { if (v.dataset.cur) start(v); }));
        this.vidObs = new IntersectionObserver((es) => es.forEach((en) => {
          if (!en.target.dataset.cur) return;
          en.isIntersecting ? en.target.play().catch(() => {}) : en.target.pause();
        }), { threshold: 0.1 });
        this.videos.forEach((v) => this.vidObs.observe(v));
      }
      disconnectedCallback() { this.stop(); this.io?.disconnect(); this.visObs?.disconnect(); this.vidObs?.disconnect(); }
      go(i, manual) {
        var n = this.slides.length;
        i = ((i % n) + n) % n;
        this.track.scrollTo({ left: i * this.track.clientWidth });
        this.setActive(i);
        if (manual && !this.userPaused) this.play();
      }
      trackView() {
        var el = this.slides[this.index];
        if (this.dataset.track !== 'true' || !this.inView || !el || this.seen.has(el)) return;
        this.seen.add(el);
        sendPromo('view_promotion', el, this.location);
      }
      setActive(i) {
        this.index = i;
        this.trackView();
        this.slides.forEach((s, k) => { s.toggleAttribute('inert', k !== i); s.setAttribute('aria-hidden', k !== i); });
        this.dots.forEach((d, k) => d.setAttribute('aria-selected', k === i));
        // reinicia la animación de progreso
        if (this.hasAttribute('data-playing')) { this.removeAttribute('data-playing'); void this.offsetWidth; this.setAttribute('data-playing', ''); }
      }
      play() {
        if (!this.canAutoplay) return;
        this.stop();
        this.setAttribute('data-playing', '');
        this.timer = setInterval(() => this.go(this.index + 1), this.interval);
      }
      stop() { clearInterval(this.timer); this.removeAttribute('data-playing'); }
    }
    customElements.define('ironside-hero-carousel', IronsideHeroCarousel);

    document.addEventListener('shopify:block:select', (e) => {
      var c = e.target.closest?.('ironside-hero-carousel');
      if (c) c.go(+e.target.dataset.index);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
